export interface MaterialCodeLine {
  id: string;
  resourceId: string;
  resource?: {
    resourceCode?: string | null;
    name?: string | null;
  } | null;
}

export const normalizeMaterialCode = (code: string): string =>
  code.trim().toLowerCase().replace(/[\s-]+/g, '');

export function findLineByMaterialCode<T extends MaterialCodeLine>(
  lines: T[],
  scannedCode: string
): T | null {
  const normalizedCode = normalizeMaterialCode(scannedCode);
  if (!normalizedCode) return null;

  return lines.find((line) => {
    const resourceCode = line.resource?.resourceCode;
    return Boolean(resourceCode && normalizeMaterialCode(resourceCode) === normalizedCode);
  }) ?? null;
}
